import createEmotion from 'create-emotion';

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context);
var flush = _createEmotion.flush;
var hydrate = _createEmotion.hydrate;
var cx = _createEmotion.cx;
var merge = _createEmotion.merge;
var getRegisteredStyles = _createEmotion.getRegisteredStyles;
var injectGlobal = _createEmotion.injectGlobal;
var keyframes = _createEmotion.keyframes;
var css = _createEmotion.css;
var sheet = _createEmotion.sheet;
var caches = _createEmotion.caches;

export { flush, hydrate, cx, merge, getRegisteredStyles, injectGlobal, keyframes, css, sheet, caches };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./~/emotion/dist/index.es.js
// module id = 8
// module chunks = 0